import React from 'react';
import './Footer.scss';
import HrbTranslate from '../language/HrbTranslate';
import ExternalLink from "../link/ExternalLink";
import VersionUtil from "../../services/util/VersionUtil";

const Footer = (props) => {

    let currentYear = (new Date()).getFullYear()
    
    return (
        <div className="hrb-footer">
            <div className="hrb-footer-copyright-item">
                <div className="hrb-footer-copyright-text"><HrbTranslate text="footer.copyright_all_rights_reserved" params={{ copyrightYear: currentYear }} /></div>
                <div><HrbTranslate text="footer.version" params={{ version: VersionUtil.getCurrentVersion() }} /></div>
            </div>
            <div className="hrb-footer-toc-privacy-item">
                <div>
                    <ExternalLink textKey="footer.terms_conditions" linkKey="links.terms_conditions" isNewWindow />
                    <span>&nbsp;|&nbsp;</span>
                    <ExternalLink textKey="footer.privacy" linkKey="links.privacy" isNewWindow />
                </div>
            </div>
        </div>
    )
}

export default Footer;